import { AbstractControl, FormControl } from '@angular/forms';

export const maskPostalCode = (control: FormControl | AbstractControl) => {
	setTimeout(() => {
		const value = control.value.replace(' ', '').toUpperCase();

		if (value.length === 6) {
			const mask = value.substring(0, 3) + ' ' + value.substring(3, 6);
			control.setValue(mask);
		}
	}, 0);
};
